import { Grid, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import TipoRemessaJulgamentoProcesso from '@/dominio/TipoRemessaJulgamentoProcesso';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import DataUtil from '@/util/DataUtil';
import ReactComponent from '../ReactComponent';

class DetalheRemessaJulgamento extends ReactComponent {
    static alturaCampo = '80px';

    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            remessaJulgamento: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get remessaJulgamento() {
        return this.registro?.remessaJulgamento;
    }

    render() {
        if (!this.remessaJulgamento) {
            return null;
        }

        return (
            <Grid
                container
                spacing={3}
            >
                <Grid size={{ xs: 12, md: 6 }}>
                    <List>
                        <ListItem sx={{ height: DetalheRemessaJulgamento.alturaCampo }}>
                            <ListItemText
                                primary="Tipo da remessa"
                                secondary={
                                    <Stack
                                        direction="row"
                                        alignItems={'center'}
                                    >
                                        {TipoRemessaJulgamentoProcesso.getIcone(this.remessaJulgamento.tipo.id)}
                                        <Typography
                                            sx={{ ml: 1 }}
                                            variant="body2"
                                        >
                                            {this.remessaJulgamento.tipo.nome}
                                        </Typography>
                                    </Stack>
                                }
                            />
                        </ListItem>
                        <ListItem sx={{ height: DetalheRemessaJulgamento.alturaCampo }}>
                            <ListItemText
                                primary="Motivo"
                                secondary={
                                    <Typography variant="body2">{this.remessaJulgamento.descricaoMotivo}</Typography>
                                }
                            />
                        </ListItem>
                    </List>
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <List>
                        <ListItem sx={{ height: DetalheRemessaJulgamento.alturaCampo }}>
                            <ListItemText
                                primary="Data da Remessa"
                                secondary={DataUtil.formatarData(this.remessaJulgamento.dataRemessa)}
                            />
                        </ListItem>
                        <ListItem sx={{ height: DetalheRemessaJulgamento.alturaCampo }}>
                            <ListItemText
                                primary="Responsável"
                                secondary={
                                    this.remessaJulgamento.autor ||
                                    this.remessaJulgamento.cpfResponsavel?.trim() ||
                                    'Informação indisponível'
                                }
                            />
                        </ListItem>
                    </List>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Paper
                        variant="outlined"
                        sx={{ p: 2 }}
                    >
                        <Typography
                            variant="subtitle2"
                            gutterBottom
                        >
                            Complemento:
                        </Typography>
                        <Typography variant="body1">{this.remessaJulgamento.complemento}</Typography>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

export default inject('stores')(observer(DetalheRemessaJulgamento));
